import axios from "axios";
import { Toast } from "vant";
import { login } from '@/utils/hybrid'


// 创建 axios 实例
const service = axios.create({
  baseURL: "/api", // api base_url
  timeout: 10000, // 请求超时时间
});

const err = (error) => {
  console.log(`拦截到错误： ${error}`)
  // console.log(`error status => ${JSON.stringify(error.response)}`)
  console.log(error)
  if (error.response) {
    const data = error.response.data;
    if (error.response.status === 403) {
      Toast({
        message: "没有访问权限",
        position: "top",
        duration: 1500,
      });
      login()
      return
    }
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
      Toast({
        message: "登录状态已过期，请重新登录",
        position: "top",
        duration: 1500,
      });
      login()
      return
    }
    if (error.response.status === 404) {
      error.message = "请求的资源不存在（404）";
    }
    if (error.response.status === 405) {
      error.message = "不支持的请求（405）";
    }
    if (error.response.status === 408) {
      error.message = "请求服务器数据超时（408）";
    }
    if (error.response.status === 500) {
      error.message = "服务器开小差了，请刷新页面重试";
    }
    if (error.response.status === 502) {
      error.message = "服务器开小差了，请刷新页面重试";
    }
    Toast({
      message: error.message,
      position: "top",
      duration: 1500,
    });
    
  } else {
    switch(error.message) {
      case 'timeout of 70000ms exceeded': error.message = '访问超时，请稍后重试'; break
      case 'Network Error': error.message = '网络连接失败，请检查您的网络后重试'; break
      default: error.message
    }
    
    Toast({
      message: error.message,
      position: "top",
      duration: 1500,
    });
    
  }
  return error
};

// request interceptor
service.interceptors.request.use((config) => {
  const headers = {
    'ws-client': 'bpapp',
    osType: "mini",
    token: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : ''
  };
  return {
    ...config,
    headers,
  };
}, err);

const succeedCode = [200, 201, 202, 203, 204]
service.interceptors.response.use((response) => {
  const data = response.data;
  if (!succeedCode.includes(data.code)) {
    if (data.code === 401) {
      Toast({
        message: "登录状态已过期，请重新登录",
        position: "top",
        duration: 1500,
      });
    } else {
      Toast({
        message: data.message || '服务不可用，服务器异常或正在维护。',
        position: "top",
        duration: 1500,
      });
      return data;
    }
  }
  return data;
}, err);

export { service as request };
